import { twMerge } from 'tailwind-merge';

import { type ErrorAny, normalizeErrors } from '../../error/utils';

export type ErrorFieldProps = {
  className?: string;
  error?: ErrorAny | ErrorAny[];
  sizeField?: 'xs' | 'sm' | 'md' | 'lg';
};

const errorSizeClassNames = {
  xs: 'font-body-3-r',
  sm: 'font-body-3-r',
  md: 'font-body-2-r',
  lg: 'font-body-2-r',
};

export function ErrorField(props: ErrorFieldProps) {
  if (props.error == null) {
    return null;
  }

  const sizeField = props.sizeField ?? 'sm';
  const classNames = errorSizeClassNames[sizeField];
  const mappedErrors = normalizeErrors(props.error);
  if (mappedErrors.length === 0) {
    return null;
  }

  return (
    <div className={twMerge('flex flex-col gap-2 text-red-500', classNames, props.className)}>
      {mappedErrors.map(function (err, i) {
        return <p key={i}>{err}</p>;
      })}
    </div>
  );
}
